import { graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import * as React from 'react';

import PrimaryLayout from '../layouts/PrimaryLayout';
import PageIntro from '../components/layout/PageIntro';
import { IPrismicComponentNode } from '../components/utils/declarations';
import usePageData from '../components/hooks/usePageData';
import CategoryCards from '../components/modules/CategoryCards';

interface IReactCategoryTemplateProps {
  data: {
    prismic: {
      allReact_categoriess: {
        edges: [
          {
            node: {
              _meta: {
                uid: string;
              };
              intro: string;
              title: string;
            };
          },
        ];
      };
      allReacts: {
        edges: [
          {
            node: IPrismicComponentNode;
          },
        ];
      };
    };
  };
}

const ReactCategoryTemplate: React.FunctionComponent<IReactCategoryTemplateProps> = ({ data }) => {
  // Required check for no data being returned
  const doc = data.prismic.allReact_categoriess.edges.slice(0, 1).pop();
  if (!doc) {
    return null;
  }

  const { title, intro } = doc.node;
  const { uid } = doc.node._meta;
  const slug = `/react/components/${uid}/`;
  const pageTitle = title && RichText.asText(title);
  const children = usePageData({ type: 'tree', slug });

  return (
    <PrimaryLayout title={pageTitle || 'Prismic Preview'} path={slug}>
      <PageIntro
        title={pageTitle || 'Prismic Preview'}
        intro={intro ? RichText.asText(intro) : undefined}
        path={slug}
      />
      <CategoryCards cardItems={children}>{pageTitle}</CategoryCards>
    </PrimaryLayout>
  );
};

export default ReactCategoryTemplate;

export const query = graphql`
  query ReactCategoryTemplateQuery($uid: String) {
    prismic {
      allReact_categoriess(uid: $uid) {
        edges {
          node {
            _meta {
              uid
            }
            intro
            title
          }
        }
      }
      allReacts {
        edges {
          node {
            title
            intro
            _meta {
              uid
              tags
            }
          }
        }
      }
    }
  }
`;
